// import React from 'react';
import clx from 'classnames';
// import dayjs from 'dayjs';
// import isBetween from 'dayjs/plugin/isBetween';
import { useFm } from '@web3/base-hooks';
import { Countdown } from '@bfe/moly';
import { initialWindowType } from '@/hooks/media';

import styles from './time.module.scss';

export const Time = ({
  startTime,
  endTime,
  isEnded,
  isNotStarted,
}: {
  startTime: number;
  endTime: number;
  isEnded: boolean;
  isNotStarted: boolean;
}) => {
  const fm = useFm();
  const { isMobile } = initialWindowType;
  // const currentTime = dayjs();

  // const isEnded = currentTime.isAfter(dayjs(endTime));
  // const isNotStarted = currentTime.isBefore(dayjs(startTime));
  return (
    // ended
    isEnded ? (
      <div className={clx([styles.wrapperEnd])}>
        {fm('aiDolSuperstarEnded')}
      </div>
    ) : (
      <div className={clx([styles.wrapper])}>
        <div className={styles.label}>
          {isNotStarted ? fm('eventStartIn') : fm('eventWillEnd')}
        </div>
        <Countdown
          targetTimestamp={isNotStarted ? startTime : endTime}
          size={!isMobile ? 'middle' : 'xsmall'}
          mode="easy"
          strong={!isMobile}
        />
      </div>
    )
  );
};
